



























































import Vue from 'vue'
import { browser } from '@/common/userAgent'
import { CommonAppData } from '@/common/types/commonAppData'
import eventBus from '@/common/utils/eventBus'
import { APP_EVENTS, APP_PATH_REGEX, SERVICE_COLOR } from '@/common/constants'
import NavBarItem  from '@/common/components/globalHeader/NavBarItem.vue'
import {
  AccountMenuItem,
  AccountNavItem,
  CartMenuItem,
  GlobalHeader as GlobalHeaderModule, SearchCategoryItem, ServiceNavBasicItem, ServiceNavItem
} from '@raksul/kamii-vue'
import { noveltyServiceNavItems, serviceNavBasicItems, SYSTEM_ERROR } from '@/common/const'
import { getJsonData } from '@/common/utils/dom'
import DrawerMenu from '@/common/components/globalHeader/DrawerMenu.vue'
import { BQ_QUERY_NAMES } from '@/common/utils'
import { getAutoCompleteSuggestions } from '@/common/service'
import debounce from 'lodash/debounce'

export default Vue.extend({
  components: {
    GlobalHeaderModule,
    NavBarItem,
    DrawerMenu
  },
  props: {
    orderHistoryCount: {
      type: Number,
      default: 0
    },
    currentUser: {
      validator: v => typeof v === 'object' || v === null,
      required: true
    },
    applicationData: {
      type: Object as () => CommonAppData,
      required: true
    }
  },
  data(): {
    favoritesCount: number,
    serviceColor: string,
    isProductMenuOpen: boolean,
    keyword: string,
    autoSuggestKeywordList: string[],
    isExistKeyword: boolean
  } {
    return {
      favoritesCount: 0,
      serviceColor: SERVICE_COLOR,
      isProductMenuOpen: false,
      keyword: '',
      autoSuggestKeywordList: [],
      isExistKeyword: false
    }
  },
  computed: {
    searchCategoryItems(): SearchCategoryItem[] {
      return [{
          label: 'すべて',
          value: 'すべて',
          url: 'https://raksul.com/search?keyword=',
          includeCategoryQuery: false,
          target: '_blank'
        },
        {
          label: '紙・シール',
          value: '紙・すべて',
          url: 'https://raksul.com/search?keyword=',
          includeCategoryQuery: true,
          target: '_blank'
        },
        {
          label: '集客支援',
          value: '集客支援・すべて',
          url: 'https://raksul.com/search?keyword=',
          includeCategoryQuery: true,
          target: '_blank'
        },
        {
          label: 'グッズ・ノベルティ',
          value: 'グッズ・ノベルティ',
          url: `${this.serviceUrl}/search?${BQ_QUERY_NAMES.SEARCH_TRACK_QUERY}=true&keyword=`,
          target: '_self',
          includeCategoryQuery: false,
          hasSuggestion: true
        },
        {
          label: '梱包材・ダンボール',
          value: '梱包材・ダンボール',
          url: 'https://search.notosiki.co.jp/?query=',
          target: '_blank',
          includeCategoryQuery: false
        },
        {
          label: 'アパレル・ユニフォーム',
          value: 'アパレル・ユニフォーム',
          url: 'https://apparel.raksul.com/search?keyword=',
          target: '_blank',
          includeCategoryQuery: false
        },
        {
          label: 'オンラインデザイン',
          value: 'オンラインデザイン',
          url: 'https://raksul.com/search?keyword=',
          includeCategoryQuery: true,
          target: '_blank'
        },
        {
          label: 'ご利用ガイド',
          value: 'ご利用ガイド',
          url: 'https://raksul.com/guide/?s=',
          includeCategoryQuery: false,
          target: '_blank'
        }
      ]
    },
    serviceUrl(): string {
      return `${window.location.protocol}//${window.location.host}`
    },
    raksulHostname(): string {
      return this.applicationData.raksul_core_url
    },
    cartMenuItem(): CartMenuItem {
      return {
        url: '/cart',
        badgeCount: this.applicationData.cart_count
      }
    },
    accountMenuItems(): AccountMenuItem[] {
      return [
      {
        label: 'メールアドレスの変更',
        url: `${this.raksulHostname}/account/settings/email`
      },
      {
        label: 'パスワードを変更',
        url: `${this.raksulHostname}/account/settings/password`
      },
      {
        label: 'メールマガジンの配信設定',
        url: `${this.raksulHostname}/account/settings/mail_magazine`
      },
      {
        label: 'クレジットカードの追加・削除',
        url: `${this.raksulHostname}/mypage/account/card`
      },
      {
        label: '出荷元の追加・削除',
        url: `${this.raksulHostname}/mypage/account/sender`
      },
      {
        label: 'お届け先の追加・削除',
        url: `${this.raksulHostname}/mypage/account/recipient`
      }
      ]
    },
    accountNavItems(): AccountNavItem[] {
      return [
        {
          icon: 'call',
          label: 'お問い合せ',
          url: `${this.serviceUrl}/contact`
        },
        {
          icon: 'list',
          label: '注文一覧',
          badgeCount: getJsonData('#orderHistoryCount') || 0,
          badgeColor: 'important',
          url: `${this.serviceUrl}/orders`
        },
        {
          icon: 'heartOutline',
          label: 'お気に入り',
          badgeCount: this.favoritesCount,
          url: `${this.serviceUrl}/estimate`
        }
      ]
    },
    isDesktopView(): boolean {
      return window.innerWidth > 1024
    },
    showServiceNav(): boolean {
      return !this.isDesktopView
    },
    serviceNavItems(): ServiceNavItem[] {
      if (this.showServiceNav) return noveltyServiceNavItems
      return []
    },
    serviceNavBasicItems(): ServiceNavBasicItem[] {
      if (this.showServiceNav) return serviceNavBasicItems
      else return []
    },
    isIE(): boolean {
      return browser.isIE
    },
    debounceSearch() {
      return this.getAutoSuggestKeywordList()
    }
  },
  watch: {
    keyword: function(newVal) {
      if (newVal === '') {
        this.autoSuggestKeywordList = []
        return
      }

      if (this.isExistKeyword) {
        this.isExistKeyword = false
        return
      }

      this.debounceSearch(newVal)
    }
  },
  created() {
    this.favoritesCount = this.applicationData.favorites_count
    eventBus.$on(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, (count: number) => {
      this.favoritesCount = count
    })

    const currentPath = window.location.pathname
    const isSearchView = (APP_PATH_REGEX.SEARCH).test(currentPath)
    if (isSearchView) {
      const parsedUrl = new URL(window.location.href)

      this.keyword = parsedUrl.searchParams.get('keyword') ?? ''

      if (this.keyword) this.isExistKeyword = true
    }
  },
  mounted() {
    const closeButton = document.querySelector('.DrawerMenuCloseButtonContainer button')
    closeButton?.addEventListener('click', () => {
      this.closeDrawerMenu()
    })
  },
  methods: {
    suggestKeywordItemClickHandler(value: string) {
      location.href = `/search?keyword=${value}&${BQ_QUERY_NAMES.SEARCH_TRACK_QUERY}=true&&${BQ_QUERY_NAMES.ClICK_SUGGESTION_QUERY}=true`
    },
    getAutoSuggestKeywordList() {
      return debounce(async newVal => {
        if (newVal === '') {
        this.autoSuggestKeywordList = []
      } else {
        const { data } = await getAutoCompleteSuggestions(newVal).catch(() => {
          alert(SYSTEM_ERROR.UNKNOWN)
          this.autoSuggestKeywordList = []
        })
        this.autoSuggestKeywordList = data.keywordAutoSuggestion.items
      }
      }, 300)
    },
    signIn(): void {
      window.location.href = '/login'
    },
    signOut(): void {
      window.location.href = '/logout'
    },
    openLinkUrl(path:string){
      window.open(
        `${this.raksulHostname}` + path,
        this.isIE ? '_self' : '_blank',
        this.isIE ? '' : 'noreferrer noopener'
      )
    },
    openDrawerMenu() {
      this.isProductMenuOpen = true
    },
    closeDrawerMenu() {
      this.isProductMenuOpen = false
    },
    keywordListResetHandler() {
      this.autoSuggestKeywordList = []
    }
  }
})
